import React from 'react'
import CommonBox from './components/CommonBox'
import GifImagesSection from './components/GifImagesSection'
import Cash2Component from './components/Cash2Component'
import BettingPageComponent from './components/BettingPageComponent'

const Betting = () => {
    return (
        <>
            <section className='betting-section'>
                <CommonBox heading=" 베팅내역 " englishHeading=" betting history" isEnglishHeadingOnMobile={true} isAuthenticated={true}>
                    <BettingPageComponent />
                </CommonBox>
            </section>
            <section className='gif-section flex lg:hidden items-center justify-center'>
                <GifImagesSection />
            </section>
        </>
    )
}

export default Betting